import { getMonthAndDay } from "../utils/funcs"

export const ProgressBar = ({ stages, currStageIdx }) => {

    const width = (100 / stages.length)

    return (
        <div className='progress-bar' >
            {
                stages.map((stage, stageIdx) =>
                    <div key={stageIdx} style={{ width: `${width}%` }} >
                        <h3>{stage.name}</h3>
                        <h4>{stage.date ? getMonthAndDay(stage.date) : ''}</h4>
                    </div>
                )
            }
            <div className='progress-line'  style={{ width: `${(currStageIdx * width - width / 2)}%` }}></div>
        </div>
    )
}